import * as tslib_1 from "tslib";
import { momentTZ as moment } from "@/helpers/moment";
import { Getter, Mutation } from "vuex-class";
import { Vue, Component, Prop } from "vue-property-decorator";
import { t } from "@/helpers/i18n";
let TimeSelector = class TimeSelector extends Vue {
    constructor() {
        super(...arguments);
        this.customDate = new Date().toISOString().substr(0, 10);
        this.dates = [];
        this.oldDates = [];
        this.showPicker = false;
        this.items = [];
    }
    created() {
        const base = t("timeRange");
        this.items = [...base];
        if (this.selected) {
            this.dates = [
                moment(this.selected.min).format("YYYY-MM-DD"),
                moment(this.selected.max).format("YYYY-MM-DD")
            ];
            this.dateSelectChange(this.dates);
        }
    }
    get selectedOption() {
        if (!this.selected)
            return this.items[0];
        // find range item first
        const range = this.selected.max - this.selected.min;
        let v = this.items.find((v) => v.value == range);
        if (v)
            return v;
        if (range < 1)
            return this.items[0];
        let min = moment(this.selected.min);
        this.customDate = min.toISOString().substring(0, 10);
        let max = moment(this.selected.max);
        const newOption = {
            key: `custom:${min.format("YYYYMMDDhhmmss")}-${max.format("YYYYMMDDhhmmss")}(${range})`,
            value: this.selected.min + this.selected.max,
            text: max.diff(min, "hours") > 23
                ? min.format("MMMM Do YYYY") + " - " + max.format("MMMM Do YYYY")
                : min.format("MMMM Do YYYY"),
            // text: min.calendar(min, calSpec) //this.$t("timeRange.custom")
            min: this.selected.min,
            max: this.selected.max
        };
        this.items.push(newOption);
        return newOption;
    }
    onDropdownChange(ob) {
        if (ob.min && ob.max) {
            return this.setTimeRange({
                widget: this.scope,
                min: ob.min,
                max: ob.max
            });
        }
        //keep time interval in 15min intervals, better caching by data service
        const ts = Math.round(moment().unix() / (60 * 15)) * (60 * 15) * 1000, min = ts - ob.value, max = ts;
        if (this.scope)
            this.setTimeRange({ widget: this.scope, min, max });
    }
    get dateBounds() {
        let min = moment(this.dates[0]);
        let max = this.dates.length > 1 ? moment(this.dates[1]) : moment(this.dates[0]);
        for (let v of this.dates) {
            let vM = moment(v);
            if (vM.isBefore(min))
                min = vM;
            if (vM.isAfter(max))
                max = vM;
        }
        return {
            min,
            max: max.add(24, "hour").subtract(1, "second") // sub 1 second to ensure its range is not the same as one of the pre-populated dropdown options
        };
    }
    dateSelectChange(selected) {
        let min = this.dateBounds.min;
        let max = this.dateBounds.max;
        let values = [];
        if (selected.length == 1) {
            values.push(selected[0]);
        }
        else if (selected.length == 2 && this.oldDates.length != 3) {
            for (let v = min; v.isSameOrBefore(max); v.add(1, "day")) {
                values.push(v.format("YYYY-MM-DD"));
            }
        }
        else {
            if (this.oldDates.length > this.dates.length) {
                for (let v of this.oldDates)
                    if (this.dates.indexOf(v) < 0) {
                        values.push(v);
                        break;
                    }
            }
            else {
                // value added
                values.push(selected[selected.length - 1]);
            }
        }
        this.dates = values;
        this.oldDates = values;
    }
    setDates() {
        if (this.scope)
            this.setTimeRange({
                widget: this.scope,
                min: this.dateBounds.min.unix() * 1000,
                max: this.dateBounds.max.unix() * 1000
            });
        this.showPicker = false;
    }
};
tslib_1.__decorate([
    Prop({ required: true })
], TimeSelector.prototype, "selected", void 0);
tslib_1.__decorate([
    Prop({ required: true })
], TimeSelector.prototype, "scope", void 0);
tslib_1.__decorate([
    Getter("tzName")
], TimeSelector.prototype, "tzName", void 0);
tslib_1.__decorate([
    Mutation("config/setTimeRange")
], TimeSelector.prototype, "setTimeRange", void 0);
TimeSelector = tslib_1.__decorate([
    Component({})
], TimeSelector);
export default TimeSelector;
